import styled from 'styled-components'
import { frameMedium } from '../mixins'

export const Container = styled.div`
  ${({ theme }) => `
    margin: auto;
    @media ${theme['tablet']}, ${theme['desktop']} {
        width: 97%;
    }
    `};
`

export const Title = styled.div`
  ${({ theme }) => `
    h1 {
        ${frameMedium({ theme })}
        border-bottom: ${theme['border-medium']} solid ${theme['main-color']};
        text-transform: capitalize;
        text-shadow: 7px 7px ${theme['color-transparent']};
        @media ${theme['tablet']}, ${theme['desktop']} {
        text-align: right;
        }
    }
    `};
`
